import { Injectable } from '@angular/core';
import { DataEntry, DataEntryTreeDto } from '@osos/shared/api';
import { DataEntryTreePresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';
import { DataEntryFactoryService } from '../../factories';

@Injectable()
export class DataEntryTreeParserV1Service extends ParserBase<
  DataEntryTreeDto,
  DataEntryTreePresenterModel
> {
  constructor(private dataEntryFactoryService: DataEntryFactoryService) {
    super(DataEntryTreeDto, DataEntryTreePresenterModel, 1);
  }
  getPresenterModel(model: DataEntryTreeDto): DataEntryTreePresenterModel {
    const dataEntryPresenterModel =
      this.dataEntryFactoryService.createPresenterModel(model as DataEntry);
    return {
      ...dataEntryPresenterModel,
      hasChildren: model.hasChildren,
      childrenCount: model.childrenCount,
      relations: model.relations,
    } as DataEntryTreePresenterModel;
  }
  getDataModel(presenter: DataEntryTreePresenterModel): DataEntryTreeDto {
    throw new Error('Method not implemented.');
  }
}
